import { render, staticRenderFns } from "./CartTable.vue?vue&type=template&id=c5f53f76&scoped=true&"
import script from "./CartTable.vue?vue&type=script&lang=js&"
export * from "./CartTable.vue?vue&type=script&lang=js&"
import style0 from "./CartTable.vue?vue&type=style&index=0&id=c5f53f76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f53f76",
  null
  
)

export default component.exports